module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-amap', {
    ref: "map",
    staticClass: "amap-demo",
    attrs: {
      "vid": "amapDemo",
      "zoom": _vm.zoom,
      "center": _vm.center,
      "plugin": _vm.plugin,
      "amap-manager": _vm.amapManager,
      "events": _vm.events
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-098ce30a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/map/index.vue
// module id = 1926
// module chunks = 2